import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "../../../TransactionsDataGrid/renderers";
import { Transfer } from "../../../../types/transfers";

interface Props extends ICellRendererParams {
  data: Transfer;
}

const ParticipantRenderer = ({ data }: Props) => {
  return (
    <TwoLineGridCell
      firstLineData={data?.participantDisplayName}
      secondLineData={data?.participantRegNumber}
    />
  );
};

export default ParticipantRenderer;
